import { forwardRef } from "react";

import { Icon, IconProps } from "../icon";

export type SortNumAscendIconProps = IconProps;

export const SortNumAscendIcon = forwardRef<
  SVGSVGElement,
  SortNumAscendIconProps
>(function SortNumAscendIcon(props: SortNumAscendIconProps, ref) {
  return (
    <Icon
      data-testid="SortNumAscendIcon"
      aria-label="sort num ascend"
      viewBox="0 0 12 12"
      ref={ref}
      {...props}
    >
      <path d="M9 9.105V1H8v8.089L6.408 7.5l-.708.706 2.808 2.803 2.8-2.795-.708-.706L9 9.105ZM3.22 4.997h-.807V1.781c0-.107.001-.214.004-.322l.007-.314c.004-.103.01-.2.017-.294-.048.052-.107.11-.178.171-.068.061-.141.125-.219.191l-.574.458-.403-.509L2.55 0h.67v4.997ZM4.4 9.191c0 .297-.02.587-.064.872a3.234 3.234 0 0 1-.219.8 2.121 2.121 0 0 1-.427.66c-.18.189-.408.337-.684.444-.275.107-.608.16-.998.16-.098 0-.212-.005-.341-.017a2.224 2.224 0 0 1-.315-.04v-.67a2.217 2.217 0 0 0 .615.081c.422 0 .75-.078.985-.235.237-.158.404-.374.502-.65.1-.276.157-.589.171-.94h-.041a1.161 1.161 0 0 1-.622.516 1.628 1.628 0 0 1-.54.079c-.287 0-.538-.06-.752-.181a1.245 1.245 0 0 1-.496-.527A1.855 1.855 0 0 1 1 8.706c0-.353.067-.657.202-.913.134-.255.324-.45.57-.587a1.73 1.73 0 0 1 .869-.209c.25 0 .482.046.693.137.215.089.402.225.561.41.16.182.284.411.373.687.088.273.133.594.133.96Zm-1.75-1.53a.808.808 0 0 0-.618.256c-.16.168-.239.428-.239.779 0 .285.068.51.205.677.137.166.346.25.629.25.196 0 .365-.04.506-.12a.91.91 0 0 0 .331-.312.706.706 0 0 0 .12-.382c0-.135-.02-.27-.058-.404a1.188 1.188 0 0 0-.171-.369.902.902 0 0 0-.294-.27.774.774 0 0 0-.41-.106Z" />
    </Icon>
  );
});
